import { render, staticRenderFns } from "./learner-facts.vue?vue&type=template&id=540fb559"
import script from "./learner-facts.ts?vue&type=script&lang=ts&external"
export * from "./learner-facts.ts?vue&type=script&lang=ts&external"
import style0 from "./learner-facts.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports